/* eslint-disable no-tabs */
const IconDropdownSvg = (props: any) => {
  return (
    <svg
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6 6L0 0H12L6 6Z" fill="white" />
    </svg>
  )
}

export default IconDropdownSvg
